import React, { useState, useEffect, useContext } from 'react'
import SubHeader from '../../../components/WithSubHeaderBG'
import ApplicationHistory from './applicationHistory'
import BalanceHistory from './balanceHistory'
import { get } from '../../../lib/api'
import { formatDate, getTokenAndUid, handlePageLoadEventLog } from '../../../lib/utils'
import OpenedNotifications from '../../Home/openedNotification'
import { Text, Box } from '../../../designSystem'
import { AccountContext } from '../../../providers/accountProvider';
import SpeakerIcon from '../../../components/Images/Megaphone'
import { MessageBody, MessageSpan, MessageHeading, } from '../../../components/MessagePopup'
import { Popup } from '../../../components/Popup'
import DropDownSelect from '../../../components/GenericDropDownSelect'
import { cautionNoteObj, cautionText1Msg, cautionText2Msg, cautionText3Msg, dummy_entity_id_for_all_book } from './constants'
import WithdrawalHistory from './withdrawalHistory'
import TermPeriodTabs from './termPeriodTabs'
import Tooltip from '../../../CustomTooltip'
import InfoIcon from '../../../components/Images/InfoIcon'
import Loader from '../../../components/Loader'

import {
  Tab,
  TabNameSpan,
  TopWalletSection,
  Anchor,
  TabsHolder,
  SingleDivSection,
  IncomeRightSection,
  BalanceRightSection,
  UnderLine,
  WalletDiv,
  TotalEarningLabel,
  SpanTag
} from './style'

const isMobile = window.screen.width < 600;
export const Wallet = ({ 
  walletDetails: { 
    total_earnings = 0, 
    balance = 0, 
    currency, 
    start_date, 
    end_date, 
    payout_date 
  } = {}, 
  bookList, 
  bookSelected, 
  updateBookSelected, 
  setCompleteBookInfo, 
  timePeriod,
  user,
  isHindiUgcUser
}) => {
  // const individualBookEarning = incomeshow?.entity_id === dummy_entity_id_for_all_book ? total_earnings : incomeshow?.total_earnings
  // const individualBookBalance = incomeshow?.entity_id === dummy_entity_id_for_all_book ? balance : incomeshow?.balance

  const textAccordingToPayoutTab = {
    'upcoming_payout' : {
      'income_text' : 'Reward',
      'balance_text': 'Payout',
      'income_info_icon': 'Reward Amount eligible for the payout cycle ',
      'balance_info_icon': 'Current payout',
      'income_date': (start_date && end_date) ? formatDate(start_date) + " - " + formatDate(end_date) : '',
      'balance_date':  payout_date ? `on ${formatDate(payout_date)}` : ''
    },
    'last_payout' : {
      'income_text' : 'Reward',
      'balance_text': 'Payout',
      'income_info_icon': 'Reward Amount paid in last Payout cycle',
      'balance_info_icon': 'Last payout',
      'income_date': (start_date && end_date) ? formatDate(start_date) + " - " + formatDate(end_date) : '',
      'balance_date': payout_date ? `on ${formatDate(payout_date, true)}` : ''
    },
    'overall' : {
      'income_text' : 'Total Income',
      'balance_text': 'Balance Amount',
      'income_info_icon': 'Total Reward Amount earned including revenue share & incentives ',
      'balance_info_icon': 'Total Reward Amount, yet to be paid ',
      'income_date': (start_date && end_date) ? formatDate(start_date) + " - " + formatDate(end_date) : '',
      'balance_date':  `as of today`
    }
  }
  const BalanceSection = () => (
    <BalanceRightSection>
      <Text variant="titleLarge" opacity={timePeriod !== 'overall' ? 0 : 'unset'}><SpanTag>{currency === 'USD' ? '$' : '₹'} {balance.toLocaleString("en-IN", {maximumFractionDigits: 2})}</SpanTag></Text>
      <TotalEarningLabel>
        {textAccordingToPayoutTab[timePeriod]['balance_text']}
        <Tooltip content={textAccordingToPayoutTab[timePeriod]['balance_info_icon']} direction="left">
          <InfoIcon />
        </Tooltip>
      </TotalEarningLabel>
      <Text fontSize={14}>{textAccordingToPayoutTab[timePeriod]['balance_date']}</Text>
    </BalanceRightSection>
  )

  const IncomeSection = () => (
    <IncomeRightSection>
      <Text variant="titleLarge"><SpanTag> {currency === 'USD' ? '$' : '₹'} {total_earnings.toLocaleString("en-IN", {maximumFractionDigits: 2})}</SpanTag></Text>
      <TotalEarningLabel>
        {textAccordingToPayoutTab[timePeriod]['income_text']}
        <Tooltip content={textAccordingToPayoutTab[timePeriod]['income_info_icon']} direction="right">
          <InfoIcon />
        </Tooltip>
      </TotalEarningLabel>
      <Text fontSize={14}>{textAccordingToPayoutTab[timePeriod]['income_date']}</Text>
    </IncomeRightSection>
  )
  return (
    <WalletDiv>
      <TopWalletSection>
        <div style={isHindiUgcUser ? isMobile ? { width: "100%"} : { width: "50%"} : {}}>
          <Box  display="flex" backgroundColor="surface.foreground">
           {!isHindiUgcUser && <Box>
              <Text varaint="titleMedium" fontWeight="b" fontSize={[20,24]}  color="var( --azure)" mr={8} mt={8} ml={4}>Novels({bookList.length-1})</Text>
            </Box>}
            <Box width={[isHindiUgcUser ? '100%' : '60vw' ,"100%"]}>
              {console.log("bookList",bookList)}
              <DropDownSelect
                name="book"
                placeholder="Select a Book"
                selectOptions={bookList}
                idKey="entity_id"
                nameKey="book_title"
                isSeries={(bookList?.filter((book) => book?.entity_id === bookSelected))?.[0]?.is_novel === 2}
                value={bookSelected}
                books
                clickOnSelect
                onChange={book => updateBookSelected(book)}
                setCompleteEntityInfo={setCompleteBookInfo}
              />
            </Box>
          </Box>
          <SingleDivSection>
            {isMobile && <IncomeSection />}
            {isMobile && <BalanceSection />}
          </SingleDivSection>
        </div>
        {!isMobile && <IncomeSection />}
        {!isMobile && <BalanceSection />}
        {/* <RightSection>
        <AvailableAmountLabel>Available : {balance.toLocaleString()}</AvailableAmountLabel>
        {!isMobile && <Tooltip
          title={!withdrawable && balance ? "You have one pending request" : ''}
          arrow
        >
          <Button variant="semiFillPrimary" sizeVariant="L" mt={4} disabled={!balance} onClick={handleWithdrawAmount}>Withdraw Money</Button>
        </Tooltip>}
      </RightSection> */}
      </TopWalletSection>

      {/* {isMobile && <Tooltip
        title={!withdrawable && balance ? "You have one pending request" : ''}
        arrow
      >
        <WithdrawCTA enabled={balance} onClick={handleWithdrawAmount}>Withdraw Money</WithdrawCTA>
        <Button variant="semiFillPrimary" sizeVariant="L" mt={8} width="100%" disabled={!balance} onClick={handleWithdrawAmount}>Withdraw Money</Button>
      </Tooltip>} */}
    </WalletDiv>
  )
}

const tabsObject = {
  withdrawals: {name: 'withdrawals', label: 'Withdrawals'},
  rewards: {name: 'rewards', label: 'Rewards', visibleTo: ['last_payout','overall', 'upcoming_payout']},
  applicationHistory: {name: 'application-history', label: 'History', visibleTo: ['overall']}
}

const Income = ({ history }) => {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const timePeriod = params.get("timePeriod") || 'upcoming_payout'
  const subTab = params.get("tab") || 'rewards'
  const urlEntityId = params.get("entity_id")
  const { user, isHindiUgcUser } = useContext(AccountContext)
  const [walletDetails, setWalletDetails] = useState({})
  const [isOpenWithdrawal, setIsOpenWithdrawal] = useState(false)
  const [isSigningOrPaymentPending, setIsSigningOrPaymentPending] = useState(false)
  const [cautionMessage, setCautionMessage] = useState('')
  const [openedNotification, setOpenedNotification] = useState(null)
  const [bookList, setBookList] = useState([])
  const [bookSelected, updateBookSelected] = useState(dummy_entity_id_for_all_book);
  const [completeBookInfo, setCompleteBookInfo] = useState(null);
  const [isAnyBooksAppliedForWBP, setAnyBooksAppliedForWBP] = useState(false)
  const [isLoading,setLoading]=useState(true);
  const tabs = 
     [
        {
          name: tabsObject.applicationHistory.name,
          label: tabsObject.applicationHistory.label,
          visibleTo: ['overall']
        },
        { 
          name: tabsObject.rewards.name, 
          label: tabsObject.rewards.label,
          visibleTo: ['last_payout','overall','upcoming_payout']
        },
        {
          name: tabsObject.withdrawals.name,
          label: tabsObject.withdrawals.label,
          visibleTo: ['last_payout','overall']
        },
  ]
   
  const selectedTab = subTab || tabsObject.rewards.name

  const fetchWalletDetails = () => {
    const { uid } = getTokenAndUid()
    let qString = ''
    if(bookSelected !== dummy_entity_id_for_all_book){
      qString = `&book_id=${bookSelected}`
    }
    get(`/content_api/book.user_wallet/${uid}/?time_period=${timePeriod}${qString}&is_novel=1`).then(response => {
      setWalletDetails(response.result)
      const { payout_date, is_contracted } = response.result
      if(is_contracted === false){
        if(timePeriod === 'upcoming_payout'){
          setCautionMessage( (new Date()).getDate() > ( payout_date ?  parseInt(payout_date?.split('/')[0]) : 7 ) ? cautionNoteObj[timePeriod]['post_payout'] : cautionNoteObj[timePeriod]['pre_payout'])
        }
        else setCautionMessage(cautionNoteObj[timePeriod])
        return
      }
    })
    
  }

  const fetchBookList = async() => {
    await get(`/user_api/wbp_books_list?is_novel=1`).then(response => {
      if(response?.length === 0){

        setLoading(false)
        return
      }
      setAnyBooksAppliedForWBP(true)


      setBookList([{
        entity_id: dummy_entity_id_for_all_book,
        entity_type: 'book',
        book_title: isHindiUgcUser ? 'All Creations' : 'All Books',
      }, ...response])
      if (urlEntityId && response) {
        const validateEntityId = response.filter(book => book.entity_id === urlEntityId)
        if (validateEntityId.length > 0) {
          setCompleteBookInfo(validateEntityId)
          updateBookSelected(urlEntityId)
        }
      }
    })
    setLoading(false)
  }

  useEffect(() => {
    if (!params.get("timePeriod")) {
      history.replace(`/income?timePeriod=${timePeriod}&tab=rewards`);
    }
    handlePageLoadEventLog('income')
    fetchBookList()
  }, [])

  const getCautionTextForAllBook = () => {
    if (bookList.length === 0) return ''
    // debugger
    const onGoingBook = bookList.filter(entity => entity.program_status === 'ongoing' && entity.entity_id !== dummy_entity_id_for_all_book)
    const textCheckForNoOpenForWithdrawal = []
    const textCheckForOpenWithdrawal = []
    if (onGoingBook.length === 0) return ''
    onGoingBook.forEach(entity => {
      if (entity.sub_status !== 'open_for_withdrawal') {
        textCheckForNoOpenForWithdrawal.push(entity)
      } else if (entity.sub_status   === 'open_for_withdrawal') {
        textCheckForOpenWithdrawal.push(entity)
      }
    })
    if (textCheckForNoOpenForWithdrawal.length) return cautionText1Msg
    if (textCheckForOpenWithdrawal.length === onGoingBook.length) return cautionText2Msg
    return ''
  }
  const getCautionTextForBook = () => {
    if(!completeBookInfo) return ''
    if (completeBookInfo[0].program_status === 'ongoing') {
      if (completeBookInfo[0].sub_status === 'open_for_withdrawal') return cautionText2Msg
      if (completeBookInfo[0].sub_status !== 'open_for_withdrawal') return cautionText3Msg
    }
    return ''
  }

  const onChangePayoutTab = (timePeriod) => {
    if(timePeriod === 'overall'){
      history.replace(`/income?timePeriod=${timePeriod}&tab=${tabsObject.applicationHistory.name}`);
    }else{
      history.replace(`/income?timePeriod=${timePeriod}&tab=${tabsObject.rewards.name}`);
    }
  }
  // useEffect(() => {
  //   if (bookList.length === 0) return
  //   if(walletDetails?.is_contracted === false){
  //     setCautionMessage(cautionNoteObj[payoutTab])
  //     return
  //   }
  //   if (bookSelected === dummy_entity_id_for_all_book) {
  //     const text = getCautionTextForAllBook()
  //     setCautionMessage(text)
  //     setIsSigningOrPaymentPending(text.length > 0)
  //     return;
  //   }
  //   const cautiontext = getCautionTextForBook()
  //   setCautionMessage(cautiontext)
  //   setIsSigningOrPaymentPending(cautiontext?.length > 0)
  // }, [bookList, bookSelected])

  useEffect(() => {
    fetchWalletDetails()
  },[bookSelected,timePeriod])


  const handleWithdrawAmount = () => {
    if (walletDetails.balance && walletDetails.total_earnings) {
      setIsOpenWithdrawal(true)
    }
  }

  const handleViewStatusClick = program => {
    setOpenedNotification(program)
  }

  const handleReset = () => {
    setOpenedNotification(null)
    setIsOpenWithdrawal(false)
    fetchBookList()
    fetchWalletDetails()
  }

  const onChangeTab = (tabName) => {
    history.push(`/income?timePeriod=${timePeriod}&tab=${tabName}`);
  }
  

  if (openedNotification) {
    return (
      <OpenedNotifications
        program={openedNotification}
        handleReset={handleReset}
      />
    )
  }
  // const showForumLink = (user?.location === "IN" || user?.location === "india" || !user?.location) && (incomeshow?.program_status === "ongoing") && (incomeshow?.language === "tamil" || incomeshow?.language === "hindi" || incomeshow?.language === "english")
  if (isOpenWithdrawal) {
    return (
      <Popup
        show={isOpenWithdrawal}
        close={() => setIsOpenWithdrawal(false)}
        renderActions={
          <>
            <button
              className="action-button primary-button"
              type="button"
              onClick={() => setIsOpenWithdrawal(false)}
            >
              Okay
            </button>
          </>
        }
      >
        <MessageHeading>
          <SpeakerIcon />
          <MessageSpan>
            Amount Withdrawal Notice
          </MessageSpan>
        </MessageHeading>
        <MessageBody>
          We release the payments on 7th of every month.<br />
          For any payment related issues, click <Anchor href="https://docs.google.com/forms/d/e/1FAIpQLSdJ3ysr4ONJMgd42_UXOzStxgv9rktk0Bv1F9QcXfAdBZVumw/viewform" target={!window.localStorage.getItem('app_origin') && "_blank"}>HERE</Anchor> to raise complaint
        </MessageBody>
      </Popup>
    )
  }
  return (
    <>
    {isLoading ? <Loader />:
    <SubHeader title="Income">
      <Box
        variant="flexCard"
        p={[16, 24]}
        borderTopLeftRadius="4px"
        borderTopRightRadius="4px"
        paddingTop={window.screen.width <= 370 ? '32px' : [16, 24]}
      >
        <Text variant="heading">Income</Text>
      </Box>
      {isAnyBooksAppliedForWBP ? <>
        <TermPeriodTabs periodTab={timePeriod} updateTabs={(tab) => onChangePayoutTab(tab)}/>
        <Box variant="hr" />
        <Wallet
          user={user}
          walletDetails={walletDetails}
          handleWithdrawAmount={handleWithdrawAmount}
          bookList={bookList}
          bookSelected={bookSelected}
          updateBookSelected={updateBookSelected}
          setCompleteBookInfo={setCompleteBookInfo}
          timePeriod={timePeriod}
          isHindiUgcUser={isHindiUgcUser}
        />
        {((walletDetails?.is_contracted === false) || (isSigningOrPaymentPending &&
        bookSelected !== dummy_entity_id_for_all_book &&
        completeBookInfo[0].program_status !== 'rejected')) && (
          <Box
            backgroundColor="rgba(242, 198, 2, 0.16)"
            borderRadius={4}
            mt={4}
            mb={4}
          >
            <Text
              fontSize={16}
              p={8}
              fontWeight="s"
              textAlign="center"
              color="#ae8701"
            >
              {cautionMessage}
            </Text>
          </Box>
        )}

        <TabsHolder isOverallSelected={timePeriod === 'overall'}>
          {tabs.map((tab, i) => tab?.visibleTo?.includes(timePeriod) && (
            <Tab
              key={tab.name}
              last={i === tabs.length - 1}
              active={selectedTab === tab.name}
              onClick={() => onChangeTab(tab.name)}
            >
              <TabNameSpan>{tab.label}</TabNameSpan>
              <UnderLine fullWidth active={selectedTab === tab.name} />
            </Tab>
          ))}
        </TabsHolder>
        {selectedTab === tabsObject.applicationHistory.name && (
          <ApplicationHistory
            onViewMoreClick={handleViewStatusClick}
            bookSelected={bookSelected}
          />
        )}
        {selectedTab === tabsObject.rewards.name && (
          <BalanceHistory
            bookSelected={bookSelected}
            payoutTabSelected={timePeriod}
            walletDetails={walletDetails}
          />
        )}
        {selectedTab === tabsObject.withdrawals.name && (
          <WithdrawalHistory 
            bookSelected={bookSelected} 
            payoutTabSelected={timePeriod}
            walletDetails={walletDetails}
          />
        )}
      </> : 
        <>
          <Box variant="hr" />
          <Box backgroundColor p={24}>
            <Text variant="title">No Books are eligible for Income, Please apply for Writers Benefit Application.</Text>
          </Box>
        </>}
    </SubHeader>}
    </>
  )
}

export default Income
